import React, { useEffect } from "react";
import "./App.css";
import { useRecoilState } from "recoil";
import { userState } from "./states/userState";
import Router from "./router/Router";
import { colorMain } from "./theme/styles";
import Loading from "./components/uikit/atoms/Loading";
function App() {
  const [user, setUser] = useRecoilState(userState);
  useEffect(() => {
    console.log("App:user", user, user.isAuth);
  }, []);

  return (
    <>
      <Loading>
        <Router />
      </Loading>
    </>
    // </div>
  );
}

export default App;
/**
 *     // <div
    //   style={{
    //     width: "100%",
    //     margin: 0,
    //     padding: 0,
    //     // minHeight: "100vh",
    //     ...colorMain(user?.mode ?? "lite"),
    //   }}
    // >
      {/* <h1>モード：{mode}</h1>
      <button onClick={() => setMode(mode === "light" ? "dark" : "light")}>
        ボタンを押してください
      </button> */
